import "./screen-list.scss";
import { IColumn } from "../../../shared/components/normal-table/normal-table";
import ListPage from "../../components/list-page/list-page";

const columns: IColumn[] = [
  {
    key: "name",
    displayName: "Name",
    dataType: {
      type: "text",
    }
  }
];

const ScreensList = () => {
  return (
    <div className="screenList">
      <ListPage
        title="Screens"
        defaultSortCol="name"
        columns={columns}
        dataUrl={{
          url: "screens",
          backend: "manager"
        }}
        deleteUrl={{
          url: "screens",
          backend: "manager"
        }}
      />
    </div>
  );
};

export default ScreensList;